import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import Particles from "react-particles-js"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { StyledButton } from "../Button"
import HeroCards from "../HeroCards"
import particlesConfig from "../../styles/particlesjs-config-hero.json"

const StyledHeader = styled.header`
  background-image: linear-gradient(to bottom, #000000 7%, #151515 99%);
  padding: 100px 0 176px;
  text-align: left;
  position: relative;
  box-shadow: 4px 4px 16px 0 rgba(0, 0, 0, 0.2);
  .particles {
    opacity: 0;
    transition: 0.2s ease;
  }
  .particles.loaded {
    opacity: 1;
  }
  .container {
    @media (min-width: 768px) {
      max-width: 576px;
      margin: 0 auto;
    }
    @media (min-width: 1024px) {
      max-width: 900px;
    }
    @media (min-width: 1200px) {
      max-width: 1200px;
    }
  }

  @media (min-width: 768px) {
    padding: 220px 0 123px;
  }
  @media (min-width: 1024px) {
    padding: 220px 0 173px;
  }
  @media (min-width: 1200px) {
    padding: 220px 0 352px;
  }
  h1 {
    font-family: "Made Evo Bold", sans-serif;
    font-size: 32px;
    line-height: 48px;
    letter-spacing: 1px;
    color: #fff;
    margin: 0 16px;
    @media (min-width: 768px) {
      letter-spacing: 1px;
      font-size: 48px;
      line-height: 60px;
      max-width: 500px;
    }
  }
`

const Description = styled.p`
  margin: 33px 16px 49px;
  letter-spacing: 0.5px;
  line-height: 32px;
  font-size: 18px;
  font-family: "Made Medium", sans-serif;
  color: #fff;
  padding-left: 16px;
  position: relative;
  &::before {
    content: "";
    width: 4px;
    height: 0;
    background-color: #f9d6c1;
    position: absolute;
    border-radius: 2px;
    left: 0;
    top: 0;
    transition: height 0.4s ease;
  }
  &.loaded {
    &::before {
      height: 100%;
    }
  }
  @media (min-width: 768px) {
    margin: 32px 16px 42px;
    letter-spacing: 0.5px;
    font-size: 20px;
    max-width: 400px;
  }
`

const Container = styled.div`
  margin: 0 16px;
  position: relative;
  z-index: 100;
  &.hero-buttons {
    margin: 0 16px 49px;
  }
  @media (min-width: 768px) {
    display: flex;
    justify-content: center;
    margin: 0 16px;
    &.hero-buttons {
      justify-content: flex-start;
      margin: 0 16px 230px 0;
    }
  }
`

const HeroButton = styled(StyledButton)`
  width: 100%;
  margin: ${props => (props.secondary ? "0 auto 32px" : "16px auto")};
  font-size: 24px;
  letter-spacing: 0.5px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 768px) {
    width: 270px;
    margin: 0 15px;
  }
`

const FlexContainer = styled.div`
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
  }
`

const HeroView = () => {
  const {
    site: {
      siteMetadata: { title, description },
    },
  } = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)
  const [isPageLoaded, setLoadedFlag] = useState(false)

  useEffect(() => {
    if (!isPageLoaded) {
      setTimeout(() => {
        setLoadedFlag(true)
      }, 400)
    }
  })
  return (
    <StyledHeader>
      <Particles
        params={particlesConfig}
        style={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}
        className={["particles", isPageLoaded && "loaded"].join(" ")}
      />
      <section className="container">
        <h1>{title}</h1>
        <Description className={isPageLoaded && "loaded"}>
          {description}
        </Description>
        <Container className="hero-buttons">
          <HeroButton as={AnchorLink} to="/#kontakt">
            Zatrudnij nas
          </HeroButton>
          <HeroButton secondary as={AnchorLink} to="/#realizacje">
            Zobacz Realizacje
          </HeroButton>
        </Container>
      </section>
      <Container>
        <HeroCards />
      </Container>
    </StyledHeader>
  )
}

export default HeroView
